<div
  #mainContainer
  id="mainContainer"
  [ngClass]="{containerClass: true, small: itemClass === 'manage-photo-grid', large: itemClass === 'product-grid'}">
  <!-- If images are processing display the overlay -->
  @if (imagesProcessing) {
    <div
      class="images-processing-overlay">
      <mat-spinner diameter="32" />
      <span class="text-primary">Updating photos...</span>
    </div>
  }
  @for (item of items; track item; let i = $index) {
    <div
      [class]="itemClass">
      <template
        [ngTemplateOutlet]="itemTemplate"
        [ngTemplateOutletContext]="{item: item, index: i}">
      </template>
    </div>
  }
</div>
